import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { VisualizationCanvasElementState } from './visualization-canvas-element.model';
import { VisualizationCanvasElementStore } from './visualization-canvas-element.store';

@Injectable({ providedIn: 'root' })
export class VisualizationCanvasElementStoreQuery extends QueryEntity<VisualizationCanvasElementState> {
  constructor(protected store: VisualizationCanvasElementStore) {
    super(store);
  }
}
